import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

export const AbilityContext = createContext();
export const Ability = createContextualCan(AbilityContext.Consumer);
